import { render } from "./HerderTeikiView.vue?vue&type=template&id=36039b29"
import script from "./HerderTeikiView.vue?vue&type=script&lang=js"
export * from "./HerderTeikiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__